// extracted by mini-css-extract-plugin
module.exports = {"saveSentenceBtn":"WordBuilder_saveSentenceBtn__3kpXR","divider":"WordBuilder_divider__20_Xu","marginTop":"WordBuilder_marginTop__12JgN"};